import React from 'react';

import classNames from 'classnames';
import SubArrowIcon from 'icons/sub-arrow.svg';
import PropTypes from 'prop-types';

export default function CountDisplay({
  count,
  countKey,
  dotClassName,
  highlightedKey,
  isSub = false,
  name,
  onClick,
  onKeyHighlight,
  onKeyUnhighlight,
}) {
  const isKeyHighlighted = countKey === highlightedKey;

  return (
    <div
      className={classNames(
        'tw-flex tw-gap-3 tw-rounded-lg tw-px-3 tw-py-2 tw-transition-colors tw-duration-200',
        count ? 'tw-cursor-pointer' : 'tw-cursor-default',
        isKeyHighlighted ? 'tw-bg-blue-025' : 'tw-bg-transparent',
      )}
      data-element-name='count-display'
      onClick={count ? onClick : undefined}
      onMouseEnter={() =>
        count ? onKeyHighlight(countKey) : onKeyUnhighlight()
      }
    >
      <div className='tw-flex tw-gap-3 tw-pt-1'>
        {isSub && (
          <SubArrowIcon
            className='[&_path]:tw-fill-grey-700'
            height={9}
            width={10}
          />
        )}
        <span
          className={classNames(
            'tw-inline-flex tw-h-2.5 tw-w-2.5 tw-rounded-full',
            dotClassName,
          )}
        />
      </div>
      <div className='tw-flex-1 tw-text-s tw-font-medium tw-tracking-wide'>
        {name}
      </div>
      <div className='tw-text-s tw-font-normal tw-tracking-wide'>{count}</div>
    </div>
  );
}

CountDisplay.propTypes = {
  count: PropTypes.number.isRequired,
  countKey: PropTypes.string.isRequired,
  dotClassName: PropTypes.string.isRequired,
  highlightedKey: PropTypes.string,
  isSub: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyHighlight: PropTypes.func.isRequired,
  onKeyUnhighlight: PropTypes.func.isRequired,
};
